import { isNil } from 'ramda';
import { matchPath } from 'react-router';

import { ROUTES, PATH } from 'constants/RoutesConstants';

export const createSearchParams = params => {
  if (!params || !Object.keys(params).length) {
    return null;
  }

  const search = new URLSearchParams();

  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      search.append(key, params[key]);
    }
  });

  return search.toString();
};

export const getQueryParam = (paramsString, param) => {
  if (!paramsString || !param) {
    return null;
  }

  const params = new URLSearchParams(paramsString);
  return params.get(param);
};

const PATH_ROUTES_CONFIG = [
  [PATH.PAYMENT.path, ROUTES.PAYMENT],
  [PATH.AFTERSALES.path, ROUTES.AFTERSALES],
  [PATH.AFTERSALES_DETAILED.path, ROUTES.AFTERSALES],
  [PATH.SELF_SERVICE_KANBAN.path, ROUTES.SELF_SERVICE_KANBAN],
  [PATH.SELF_SERVICE_MOBILITY.path, ROUTES.SELF_SERVICE_MOBILITY],
  [PATH.FOLLOW_UP.path, ROUTES.FOLLOW_UP],
  [PATH.BODYWORKS.path, ROUTES.BODYWORKS],
  [PATH.BODYWORKS_DETAILED.path, ROUTES.BODYWORKS],
  [PATH.REMINDERS.path, ROUTES.REMINDERS],
  [PATH.REMINDERS_DETAILED.path, ROUTES.REMINDERS],
  [PATH.AUDITS.path, ROUTES.AUDITS],
  [PATH.AUDITS_DETAILED.path, ROUTES.AUDITS_DETAILED],
  [PATH.CUSTOMERS.path, ROUTES.CUSTOMERS],
  [PATH.CUSTOMERS_DETAILED.path, ROUTES.CUSTOMERS],
  [PATH.STATS_ODITOO.path, ROUTES.STATS_AUDITS],
  [PATH.STATS_ODITOO.simplePath, ROUTES.STATS_AUDITS],
  [PATH.SALES.path, ROUTES.SALES],
  [PATH.SALES_DETAILED.path, ROUTES.SALES],
  [PATH.CONFIGURATOR_OFFERS.path, ROUTES.CONFIGURATOR_OFFERS],
  [PATH.CONFIGURATOR_OFFERS_DETAILED.path, ROUTES.CONFIGURATOR_OFFERS],
  [PATH.CONFIGURATOR_MODELS.path, ROUTES.CONFIGURATOR_MODELS],
  [PATH.KEY_DROP_OFF_LOCKER_DETAILED.path, ROUTES.KEY_DROP_OFF_LOCKER_DETAILED],
  [PATH.KEY_DROP_OFF_LOCKER_PLANNING.path, ROUTES.KEY_DROP_OFF_LOCKER_PLANNING],
  [PATH.KEY_DROP_OFF_APPOINTMENTS.path, ROUTES.KEY_DROP_OFF_APPOINTMENTS],
  [PATH.KEY_DROP_OFF_APPOINTMENTS_DETAILED.path, ROUTES.KEY_DROP_OFF_APPOINTMENTS],
  [PATH.GROUP_MANAGEMENT.path, ROUTES.GROUP_CONFIGURATION],
  [PATH.PERSONAL_CONFIG.path, ROUTES.PERSONAL_CONFIGURATION],
  [PATH.DEALER_MANAGEMENT.path, ROUTES.DEALER_MANAGEMENT],
  [PATH.CHECKLISTS.path, ROUTES.CHECKLISTS],
  [PATH.CHECKLISTS_DETAILED.path, ROUTES.CHECKLISTS],
  [PATH.USER_GROUPS.path, ROUTES.USER_GROUPS],
  [PATH.USERS.path, ROUTES.USERS],
  [PATH.USERS_DETAILED.path, ROUTES.USERS],
  [PATH.DEVICES.path, ROUTES.DEVICES],
  [PATH.GROUP_DEVICES.path, ROUTES.GROUP_DEVICES],
  [PATH.DEALERS.path, ROUTES.DEALERS],
  [PATH.DEALERS_DETAILS.path, ROUTES.DEALERS],
  [PATH.AUDIT_MODELS.path, ROUTES.AUDIT_MODELS],
  [PATH.AUDIT_MODELS_DETAILED.path, ROUTES.AUDIT_MODELS],
  [PATH.PROFILE.path, ROUTES.PROFILE],
  [PATH.CHAT.path, ROUTES.CHAT],
  [PATH.CHAT.simplePath, ROUTES.CHAT],
  [PATH.SAFE_CONFIG.path, ROUTES.SAFE_CONFIG],
  [PATH.HOME.path, ROUTES.HOME],
  [PATH.ERROR_404.path, ROUTES.ERROR_404],
  [PATH.ERROR_GLOBAL.path, ROUTES.ERROR_GLOBAL],
  [PATH.GUIDELINES_DASHBOARD.path, ROUTES.GUIDELINES_DASHBOARD],
  [PATH.GUIDELINE_DETAILED.path, ROUTES.GUIDELINE_DETAILED],
  [PATH.GROUP_CHECKLISTS_CONFIG.path, ROUTES.GROUP_CHECKLISTS],
  [PATH.GROUP_TEMPLATES_CONFIG.path, ROUTES.GROUP_TEMPLATES],
  [PATH.GROUP_GUIDELINES_CONFIG.path, ROUTES.GROUP_GUIDELINES],
  [PATH.GROUP_GUIDELINE_DETAILED.path, ROUTES.GROUP_GUIDELINE_DETAILED],
  [PATH.USER_NOTIFICATIONS_SETTINGS.path, ROUTES.USER_NOTIFICATIONS_SETTINGS],
  [PATH.USER_NOTIFICATIONS.path, ROUTES.USER_NOTIFICATIONS],
  [PATH.PREDEFINED_MESSAGES_DETAILED.path, ROUTES.PREDEFINED_MESSAGES_DETAILED],
  [PATH.PREDEFINED_MESSAGES_DASHBOARD.path, ROUTES.PREDEFINED_MESSAGES_DASHBOARD],
  [PATH.OFFERS_DASHBOARD.path, ROUTES.OFFERS_DASHBOARD],
  [PATH.OFFERS_DETAILED.path, ROUTES.OFFERS_DASHBOARD],
  [PATH.GROUP_OFFERS.path, ROUTES.GROUP_OFFERS],
  [PATH.STATS_SALES.path, ROUTES.STATS_SALES],
  [PATH.STATS_AFTER_SALES.path, ROUTES.STATS_AFTER_SALES],
  [PATH.STATS_SALES_DETAILS.path, ROUTES.STATS_SALES_DETAILS],
  [PATH.STATS_AFTER_SALES_DETAILS.path, ROUTES.STATS_AFTER_SALES_DETAILS],
  [PATH.SELF_SERVICE_STATS_DASHBOARD.path, ROUTES.SELF_SERVICE_STATS_DASHBOARD],
  [PATH.SELF_SERVICE_STATS_DETAILS.path, ROUTES.SELF_SERVICE_STATS_DETAILS],
  [PATH.MANUFACTURER_STATS_SALES.path, ROUTES.MANUFACTURER_STATS_SALES],
  [PATH.MANUFACTURER_STATS_AFTER_SALES.path, ROUTES.MANUFACTURER_STATS_AFTER_SALES],
  [PATH.MANUFACTURER_STATS_SALES_DETAILS.path, ROUTES.MANUFACTURER_STATS_SALES_DETAILS],
  [PATH.MANUFACTURER_STATS_AFTER_SALES_DETAILS.path, ROUTES.MANUFACTURER_STATS_AFTER_SALES_DETAILS],
  [PATH.STEPS_DASHBOARD.path, ROUTES.STEPS_DASHBOARD],
  [PATH.STEPS_DETAILS.path, ROUTES.STEPS_DETAILS],
  [PATH.LEADS.path, ROUTES.LEADS],
  [PATH.QUESTION_MODEL_DETAILED.path, ROUTES.QUESTION_MODEL_DETAILED],
  [PATH.VEHICLE_CHECK_MODEL_DETAILED.path, ROUTES.VEHICLE_CHECK_MODEL_DETAILED],
  [PATH.DEALER_EXTRA_DASHBOARD.path, ROUTES.DEALER_EXTRA_DASHBOARD],
  [PATH.DEALER_QUESTION_MODEL_DASHBOARD.path, ROUTES.DEALER_QUESTION_MODEL_DASHBOARD],
  [PATH.DEALER_VEHICLE_CHECK_MODEL_DASHBOARD.path, ROUTES.DEALER_VEHICLE_CHECK_MODEL_DASHBOARD],
  [PATH.GROUP_EXTRA_DASHBOARD.path, ROUTES.GROUP_EXTRA_DASHBOARD],
  [PATH.GROUP_QUESTION_MODEL_DASHBOARD.path, ROUTES.GROUP_QUESTION_MODEL_DASHBOARD],
  [PATH.GROUP_VEHICLE_CHECK_MODEL_DASHBOARD.path, ROUTES.GROUP_VEHICLE_CHECK_MODEL_DASHBOARD],
  [PATH.DEALER_EXTRA_DETAILED.path, ROUTES.DEALER_EXTRA_DETAILED],
  [PATH.MESSAGE_BILLING.path, ROUTES.MESSAGE_BILLING],
  [PATH.CLIPPING_BILLING.path, ROUTES.CLIPPING_BILLING],
  [PATH.AUTOMATED_DOCUMENT_BILLING.path, ROUTES.AUTOMATED_DOCUMENT_BILLING],
  [PATH.PHONE_AGENT_BILLING.path, ROUTES.PHONE_AGENT_BILLING],
  [PATH.MEDIA_LIBRARY_DEALER.path, ROUTES.MEDIA_LIBRARY_DEALER],
  [PATH.MEDIA_LIBRARY_GROUP.path, ROUTES.MEDIA_LIBRARY_GROUP],
  [PATH.MEDIA_LIBRARY_PERSONAL.path, ROUTES.MEDIA_LIBRARY_PERSONAL],
  // Parts
  [PATH.PARTS.path, ROUTES.PARTS],
  [PATH.PARTS_DETAILED.path, ROUTES.PARTS_DETAILED],
  [PATH.STATS_PARTS.path, ROUTES.STATS_PARTS],
  [PATH.STATS_PARTS_DETAILS.path, ROUTES.STATS_PARTS_DETAILS],
  [PATH.MANUFACTURER_STATS_PARTS.path, ROUTES.MANUFACTURER_STATS_PARTS],
  [PATH.MANUFACTURER_STATS_PARTS_DETAILS.path, ROUTES.MANUFACTURER_STATS_PARTS_DETAILS],
  [PATH.PARTS_REMINDER.path, ROUTES.PARTS_REMINDER],
  [PATH.PARTS_REMINDER_DETAILED.path, ROUTES.PARTS_REMINDER_DETAILED],
  // Parts offers
  [PATH.GROUP_PARTS_OFFERS.path, ROUTES.GROUP_PARTS_OFFERS],
  [PATH.DEALER_PARTS_OFFERS.path, ROUTES.DEALER_PARTS_OFFERS],
  [PATH.PARTS_OFFERS_DETAILS.path, ROUTES.PARTS_OFFERS_DETAILS],
  // Kiosks
  [PATH.KIOSKS.path, ROUTES.KIOSKS],
  [PATH.KIOSKS_DETAILS.path, ROUTES.KIOSKS_DETAILS],
  // Camera
  [PATH.CAMERAS, ROUTES.CAMERAS],
  [PATH.CAMERAS_DETAILS, ROUTES.CAMERAS_DETAILS],
  // Hardware
  [PATH.HARDWARES, ROUTES.HARDWARES],
  // Payers
  [PATH.GROUP_PAYERS, ROUTES.GROUP_PAYERS],
  [PATH.GROUP_PAYERS_DETAILS, ROUTES.GROUP_PAYERS_DETAILS],
  [PATH.PAYERS, ROUTES.PAYERS],
  [PATH.PAYERS_DETAILS, ROUTES.PAYERS_DETAILS],
  // Dealer config
  [PATH.DEALER_CONFIG_PAGE.path, ROUTES.DEALER_CONFIG_PAGE],
  // Campaigns
  [PATH.CAMPAIGNS_DASHBOARD.path, ROUTES.CAMPAIGNS_DASHBOARD],
  [PATH.CAMPAIGNS_DETAILS.path, ROUTES.CAMPAIGNS_DETAILS],
  [PATH.CONTACT_LISTS_DASHBOARD.path, ROUTES.CONTACT_LISTS_DASHBOARD],
  [PATH.CONTACT_LISTS_DETAILS.path, ROUTES.CONTACT_LISTS_DETAILS],
  [PATH.RELEASES_DASHBOARD.path, ROUTES.RELEASES_DASHBOARD],
  [PATH.RELEASES_DETAILS.path, ROUTES.RELEASES_DETAILS],
];

/**
 * @param {string} location
 * @returns {keyof typeof PATH | undefined} the `PATH` key of the route the location matches, if `ROUTES` declares it too
 */
export const getRoutePath = (location) => Object.entries(PATH).find(
  ([field, { path }]) => Boolean(matchPath(path, location) && ROUTES[field])
)?.at(0);

/**
 * @param {string} location
 * @returns {string | null} the `ROUTES` entity the location resolves to
 */
export const getCurrentRoute = location => {
  const result = PATH_ROUTES_CONFIG.find(([path]) => !isNil(matchPath(path, location)));
  return result?.[1] ?? getRoutePath(location) ?? null;
};
